import { render, staticRenderFns } from "./equipments.vue?vue&type=template&id=20a945e8&scoped=true&"
import script from "./equipments.vue?vue&type=script&lang=js&"
export * from "./equipments.vue?vue&type=script&lang=js&"
import style0 from "./equipments.vue?vue&type=style&index=0&id=20a945e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a945e8",
  null
  
)

export default component.exports